<template>
  <div class="user-drawer__content">
    <p class="user-drawer__title">
      {{$t('user.add.title')}}
    </p>

    <el-divider></el-divider>

    <el-form :model="newUserForm" :rules="rules" ref="newUserForm" label-width="120px" class="demo-ruleForm" v-loading="loading">
      <el-form-item :label="$t('user.add.form.username')" prop="username">
        <el-input size="small" v-model="newUserForm.username"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.add.form.email')" prop="email">
        <el-input size="small" v-model="newUserForm.email"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.add.form.password')" prop="password">
        <el-input size="small" v-model="newUserForm.password" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.add.form.role')" prop="role">
        <el-select v-model="newUserForm.role" size="small" :placeholder="$t('user.add.form.role')">
          <el-option
            v-for="item in roles"
            :key="item.value"
            :label="item.title"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('user.add.form.group')" prop="group">
        <el-input size="small" v-model="newUserForm.group"></el-input>
      </el-form-item>
      <el-form-item label="Кол-во лент" prop="max_threads">
        <el-input size="small" v-model="newUserForm.max_threads" @input="handleChangeThreads"></el-input>
      </el-form-item>
      <el-form-item label="Город" prop="map_center" v-if="isAdmin">
        <el-input size="small" v-model="newUserForm.map_center"></el-input>
      </el-form-item>
      <el-form-item class="manage" prop="manage_keywords" v-if="isAdmin">
        <el-checkbox v-model="newUserForm.manage_keywords" label="Доступ к редактированию ключевых слов"></el-checkbox>
        <el-checkbox v-model="isIaoApi" label="Доступ к обмену ИС ИАО"></el-checkbox>
        <el-checkbox v-model="newUserForm.b2b_user" label="Доступ к функционалу b2b"></el-checkbox>
      </el-form-item>

      <el-divider></el-divider>

      <div class="user-footer">
        <el-button
          size="medium"
          type="primary"
          @click="handleEdit('newUserForm')">{{$t('user.add.form.addButton')}}</el-button>
        <el-button
          size="medium"
          @click="resetForm('newUserForm')">{{$t('user.add.form.cancelButton')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>

  /*
    adding a user appears on the panel, the template is taken from the settings config ../config/header
  */

  // store
  import {ADD_USER} from "../../store/actions/users";

  // components
  import notify from "../../helpers/notify";
  import {mapGetters} from 'vuex';
  import { iaoApi } from '../../helpers/iaoApi';

  export default {
    name: "AddUser",
    data() {
      return {
        loading: false,
        newUserForm: {
          username: '',
          email: '',
          password: '',
          role: '',
          group: '',
          map_center: '',
          manage_keywords: false,
          b2b_user: false,
          max_threads: 0,
          isIaoApi: false,
        },
        roles: this.$t('user.add.roles'),
        rules: this.$t('user.add.rules'),
      };
    },
    computed: {
      ...mapGetters([
        'isAdmin',
      ]),
    },
    methods: {
      handleChangeThreads(value) {
        const maxThreadsLimit  = 65535;
        if (this.newUserForm.max_threads) {
          this.newUserForm.max_threads = parseInt(value);
          if (this.newUserForm.max_threads > maxThreadsLimit) {
            this.newUserForm.max_threads = maxThreadsLimit;
          }
        } else {
          this.newUserForm.max_threads = 0;
        }
      },
      handleEdit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.newUserForm.group = Number(this.newUserForm.group);
            this.newUserForm.api_admin = this.isIaoApi ? iaoApi() : 0

            this.loading = true;
            this.$store.dispatch(ADD_USER, this.newUserForm).then(() => {
              this.loading = false;
              this.resetForm(formName);
              notify.call(this, this.$t('user.add.notify.add'), "success");
            }).catch(() => {
              this.loading = false;
              notify.call(this, this.$t('user.add.notify.serverError'), "error");
            });
          } else {
            this.loading = false;
            notify.call(this, this.$t('user.add.notify.error'), "error");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
  };
</script>

<style>
  .user-drawer__content {
    margin: 0 15px 0 15px;
  }
  .user-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
    @media screen and (max-width: 480px) {
    .el-form-item.manage .el-form-item__content{
      margin-left: 0px!important;
      }
    }
</style>
